import { useEffect } from 'react';

export const useRTETooltipPositionCorrector = (isMobile = false) => {
  useEffect(() => {
    const getClippingAncestor = (element: HTMLElement) => {
      let currentElement: HTMLElement | null = element.parentElement;
      while (currentElement && currentElement !== document.body) {
        const style = window.getComputedStyle(currentElement);
        if (
          style.overflow === 'hidden' ||
          style.overflowX === 'hidden' ||
          style.overflow === 'auto' ||
          style.overflowX === 'auto'
        ) {
          return currentElement;
        }
        currentElement = currentElement.parentElement;
      }
      return document.body;
    };

    const checkTooltipPosition = (
      triggerElement: HTMLElement,
      tooltipElement: HTMLElement
    ) => {
      const closestElement = getClippingAncestor(triggerElement);
      const triggerRect = triggerElement.getBoundingClientRect();

      tooltipElement.style.left = '';
      tooltipElement.style.width = '';
      tooltipElement.style.maxWidth = '';

      const tooltipRect = tooltipElement.getBoundingClientRect();
      const closestRect = closestElement.getBoundingClientRect();

      if (triggerRect.x - tooltipRect.width / 2 < closestRect.x) {
        tooltipElement.style.left = `${
          closestRect.x - (triggerRect.x - tooltipRect.width / 2) + 10
        }px`;
      } else if (triggerRect.x + tooltipRect.width / 2 > closestRect.right) {
        tooltipElement.style.left = `${
          closestRect.right - (triggerRect.x + tooltipRect.width / 2) - 10
        }px`;
      }

      if (closestRect.width < tooltipRect.width) {
        tooltipElement.style.width = `${closestRect.width - 20}px`;
        tooltipElement.style.maxWidth = `${closestRect.width - 20}px`;
        tooltipElement.style.whiteSpace = 'normal';
      }

      if (isMobile) {
        const hasBottomClass =
          Array.from(triggerElement.classList).some((className) =>
            new RegExp('bottom', 'i').test(className)
          ) ||
          Array.from(tooltipElement.classList).some((className) =>
            new RegExp('bottom', 'i').test(className)
          );
        if (hasBottomClass) {
          tooltipElement.style.top = `${
            triggerRect.height + tooltipElement.offsetHeight
          }px`;
        }
      }
    };

    let hoverTimeout: NodeJS.Timeout | null = null;
    let currentTrigger: HTMLElement | null = null;
    let currentTooltip: HTMLElement | null = null;

    const handleMouseOver = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target) return;

      const triggerElement = target.closest('.tt') as HTMLElement;
      if (!triggerElement) {
        if (currentTooltip && currentTrigger) {
          if (!currentTooltip.contains(target)) {
            currentTooltip = null;
            currentTrigger = null;
          }
        }
        return;
      }

      const tooltipElement = triggerElement.querySelector(
        '.tt__content'
      ) as HTMLElement;

      if (tooltipElement && currentTrigger !== triggerElement) {
        if (hoverTimeout) clearTimeout(hoverTimeout);
        currentTrigger = triggerElement;
        currentTooltip = tooltipElement;

        hoverTimeout = setTimeout(() => {
          checkTooltipPosition(triggerElement, tooltipElement);
        }, 100);
      }
    };

    document.addEventListener('mouseover', handleMouseOver);

    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
      if (hoverTimeout) clearTimeout(hoverTimeout);
    };
  }, [isMobile]);
};
